var style="\n    .p-radiobutton-group {\n        display: inline-flex;\n    }\n";export{style};//# sourceMappingURL=index.mjs.map